import React, { useState, useEffect, useCallback } from 'react';
import { API_ADDRESS, PAGE_TITLE_BASE } from './constants.js';
import { Dimmer, Loader, Segment } from 'semantic-ui-react'
import { PlaylistCard } from "./PlaylistCard";

export function Playlist(props) {
  const [loading, setLoading] = useState(true);
  const [playlist, setPlaylist] = useState([]);

  document.title = 'Playlist | ' + PAGE_TITLE_BASE;

  const search = useCallback(() => {
    let url = `${API_ADDRESS}/playlist`;
  
    fetch(url)
      .then(function(response) {
        return response.json()
      })
      .then(function(json) {
        if(!json['error']) {
          setPlaylist(json);
        }
        setLoading(false);
      })
      .catch(function(ex) {
        setLoading(false);
        console.log(ex);
      })
  }, []); 

  useEffect(() => { if(loading) { search() } }, [loading, search])

  return (
    <div>
      <Segment className="browse-table-segment">
        <Dimmer active={loading}>
          <Loader size='large'>Loading</Loader>
        </Dimmer>
        <h1>Latest Releases Playlist</h1>
        <p>We maintain a playlist of all the latest releases from the British vocal jazz scene. You can find the Spotify link below, and see the archived tracks listed below.</p>
        <iframe data-testid="embed-iframe" style={{borderRadius: "12px"}} src="https://open.spotify.com/embed/playlist/35HMKE0uwVl8w0Ln4e3u9R?utm_source=generator" width="100%" height="352" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Spotify"></iframe>
        <div className="Cards">
          {Object.keys(playlist).length > 0 && Object.keys(playlist).sort().reverse().map(function(date, i) {
            let entries_for_date = playlist[date];
            return <PlaylistCard key={date} date={date} playlist={entries_for_date} i={i}/>
          })}
          {Object.keys(playlist).length === 0 &&
            <b>No results</b>
          }
        </div>
      </Segment>
    </div>
  );
};
